import React from "react";
import Tag from "./Tag";

export default ({ title, tagList, selectedTags, name, select, unselect }) => (
  <div>
    <h3>{title}</h3>
    <div className="tags-container">
      {" "}
      {tagList.map((tag, index) => (
        <Tag
          selected={selectedTags.includes(tag)}
          label={tag}
          key={`${name}-tags-${index}`}
          select={() => select(tag, name)}
          unselect={() => unselect(tag, name)}
        />
      ))}
    </div>
  </div>
);
